import React, { useState, useEffect } from 'react';
import { useWebHaptics } from "web-haptics/react";
import '../styles/GameBoard.css';

const ATTRIBUTES = ['game', 'element', 'speed', 'health', 'armor', 'gender', 'color'];

function GuessRow({ guess, results, isNew }) {
  const { trigger } = useWebHaptics();
  const [flippingCells, setFlippingCells] = useState([]);
  const [revealedCells, setRevealedCells] = useState([]);

  useEffect(() => {
    if (isNew) {
      // Trigger flip animation for each cell with staggered delay
      ATTRIBUTES.forEach((attr, index) => {
        setTimeout(() => {
          // Trigger haptic feedback for tile flip
          trigger([{ duration: 35 }], { intensity: 1 });
          
          setFlippingCells(prev => [...prev, attr]);
          
          // Remove flipping class and add to revealed after animation
          setTimeout(() => {
            setFlippingCells(prev => prev.filter(a => a !== attr));
            setRevealedCells(prev => [...prev, attr]);
          }, 500); // Match animation duration
        }, index * 500); // Stagger by 500ms
      });
    } else {
      // For rows that aren't new (loaded from storage), show them immediately
      setRevealedCells(ATTRIBUTES);
    }
  }, [isNew, trigger]);

  const getCellClass = (attr, result) => {
    const baseClass = [];
    
    if (result.status === 'correct') baseClass.push('correct');
    else if (result.status === 'partial') baseClass.push('partial');
    else baseClass.push('incorrect');
    
    if (flippingCells.includes(attr)) baseClass.push('flipping');
    if (!revealedCells.includes(attr) && !flippingCells.includes(attr)) baseClass.push('pre-flip');
    
    return baseClass.join(' ');
  };

  const getDisplayValue = (attr, result) => {
    // For numeric attributes with direction indicator
    if (result.direction) {
      return `${result.value} ${result.direction}`;
    }
    return result.value;
  };

  return (
    <div className="guess-row">
      <div className="guess-name">{guess}</div>
      {ATTRIBUTES.map((attr) => (
        <div key={attr} className={`attribute-cell ${getCellClass(attr, results[attr])}`}>
          <div className="attr-label">{attr.toUpperCase()}</div>
          <div className="attr-value">{getDisplayValue(attr, results[attr])}</div>
        </div>
      ))}
    </div>
  );
}

export default GuessRow;
